import { render, staticRenderFns } from "./SupplierShops.vue?vue&type=template&id=3c5c89e6&"
import script from "./SupplierShops.vue?vue&type=script&lang=ts&"
export * from "./SupplierShops.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports